import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Phone } from 'src/app/shared/components/phone/shared/model';

export const CreateFormPhone = (resource: Phone): UntypedFormGroup => {
  const fb = new UntypedFormBuilder();
  const resoureData = resource || new Phone();

  return fb.group({
    id: [resoureData.id],
    number: [resoureData.number, [Validators.required]],
    phone_type: [resoureData.phone_type, [Validators.required]],
    primary: [resoureData.primary],
    send_notification: [resoureData.send_notification],
    obs: [resoureData.obs],
    deleted: [resoureData.deleted, [Validators.required]],
    whatsapp: [resoureData.whatsapp]
  });
};
